// Pricing constants and utilities
// Note: Pricing values are now fetched from the API via usePricingSettings hook
// These are fallback defaults and helper functions

export const DEFAULT_PRICING = {
  // Tax rate as decimal (0 = free)
  TAX_RATE: 0,
  
  // Fixed delivery fee in Naira (0 = free)
  DELIVERY_FEE: 0,
} as const;

// Helper functions for price calculations
export function calculateTax(subtotal: number, taxRate: number = DEFAULT_PRICING.TAX_RATE): number {
  return subtotal * taxRate;
}

export function calculateTotal(
  subtotal: number,
  taxRate: number = DEFAULT_PRICING.TAX_RATE,
  deliveryFee: number = DEFAULT_PRICING.DELIVERY_FEE
): number {
  const tax = calculateTax(subtotal, taxRate);
  return subtotal + tax + deliveryFee;
}

export function formatPrice(amount: number): string {
  return `₦${amount.toLocaleString()}`;
}

// Check if tax/delivery is free
export function isTaxFree(taxRate: number = DEFAULT_PRICING.TAX_RATE): boolean {
  return taxRate === 0;
}

export function isDeliveryFree(deliveryFee: number = DEFAULT_PRICING.DELIVERY_FEE): boolean {
  return deliveryFee === 0;
}
